import { Newspaper, MoonStar, CalendarX, ShieldCheck, Check, X } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";

const RULES = [
  {
    icon: Newspaper,
    title: "News Trading",
    ok: true,
    badge: "ALLOWED IN CHALLENGE",
    desc: "Trade news freely during evaluation. On Funded Accounts, no new trades ±5 mins around high-impact releases.",
    nuance: "Restricted ±5 min on funded",
  },
  {
    icon: MoonStar,
    title: "Overnight Holding",
    ok: true,
    badge: "ALLOWED",
    desc: "Hold positions across sessions and through the daily rollover without penalty.",
  },
  {
    icon: CalendarX,
    title: "Weekend Holding",
    ok: false,
    badge: "NOT ALLOWED",
    desc: "All positions must be closed before the Friday market close — except on Swing plans, where weekend holding is allowed.",
  },
  {
    icon: ShieldCheck,
    title: "KYC Verification",
    ok: true,
    badge: "PAYOUT ONLY",
    desc: "No KYC at registration or when you get funded. Verify identity only when requesting your first payout.",
  },
];

export default function RulesGlance() {
  return (
    <section id="rules" className="py-24 lg:py-32 bg-[#0D0E13] relative" data-testid="rules-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center flex flex-col items-center">
          <div className="flex items-center gap-4 mb-6">
            <span className="eyebrow">02</span>
            <span className="h-px w-10 bg-gradient-to-r from-[#FFD700] to-transparent" />
            <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#999999]">Rules at a Glance</span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-[-0.04em] text-white">
            No hidden fine print.
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#999999] max-w-xl">
            Everything you need to know before you click buy — skimmed in ten seconds.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {RULES.map((r, i) => (
            <Reveal key={r.title} delay={i * 0.08}>
              <div
                className="glass-card rounded-2xl p-6 h-full relative overflow-hidden"
                data-testid={`rule-card-${i}`}
              >
                <div
                  className={`absolute top-0 left-0 right-0 h-[2px] ${
                    r.ok ? "bg-gradient-to-r from-[#22C55E] to-transparent" : "bg-gradient-to-r from-[#EF4444] to-transparent"
                  }`}
                />
                <div className="flex items-start justify-between mb-5">
                  <div className={`w-11 h-11 rounded-xl flex items-center justify-center border ${
                    r.ok ? "bg-[#22C55E]/10 border-[#22C55E]/25" : "bg-[#EF4444]/10 border-[#EF4444]/25"
                  }`}>
                    <r.icon size={20} className={r.ok ? "text-[#22C55E]" : "text-[#EF4444]"} />
                  </div>
                  <span className={`inline-flex items-center gap-1 text-[10px] font-bold tracking-[0.12em] uppercase ${
                    r.ok ? "text-[#22C55E]" : "text-[#EF4444]"
                  }`}>
                    {r.ok ? <Check size={12} /> : <X size={12} />}
                  </span>
                </div>
                <h3 className="text-lg font-semibold tracking-[-0.02em] text-white">{r.title}</h3>
                <div className={`mt-1 text-[11px] font-bold uppercase tracking-[0.15em] ${
                  r.ok ? "text-[#22C55E]" : "text-[#EF4444]"
                }`}>
                  {r.badge}
                </div>
                <p className="text-sm text-[#999999] mt-3 leading-relaxed">{r.desc}</p>
                {r.nuance && (
                  <div className="mt-3 text-xs text-[#2DACE2] font-medium">{r.nuance}</div>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
